import React, { useState, useEffect } from "react";

import VuiBox from "components/VuiBox";
import VuiButtonCustom from "components/VuiButtonCustom";
import VuiTypography from "components/VuiTypography";

import VuiLabel from "components/VuiLabel";
import VuiModal from "components/VuiModal";
import colors from "assets/theme/base/colors";

import moment from "moment";

import { capitalize } from "helpers/utilities";

import {
  DashboardGrid,
  ServerHeader,
  ServerName,
  ServerDomain,
  ServerStatus,
  ServerStatusHeader,
  ServerStatusOnline,
  ServerStatusOffline,
  InfoRow,
  InfoLabel,
  InfoValue,
} from "./styles";

const stageLabel = [
  { label: "Operacional", color: colors.success.status },
  { label: "Alerta 1", color: colors.alert.main },
  { label: "Alerta 2", color: colors.warning.main },
  { label: "Crítica", color: colors.error.main },
];

function rulesHostNameColor(hostname) {
  if (hostname) {
    if (hostname.substr(0, 3) === "NT-" || hostname.substr(0, 3) === "PC-") {
      return "#0f1535";
    }
  }
  return "#bd0000";
}

function SLIOccurrence(d1, d2) {
  const ms = moment(d1, "DD/MM/YYYY HH:mm:ss").diff(moment(d2, "DD/MM/YYYY HH:mm:ss"));
  const d = moment.duration(ms);
  return Math.floor(d.asHours()) + "h" + moment.utc(ms).format(" mm") + "m";
}

function VuiInfoItemLink({ item, index }) {
  // console.log(">>> item", item);
  if (item) {
    return (
      <>
        <DashboardGrid>
          <ServerHeader>
            <ServerStatusHeader>
              <ServerName color={rulesHostNameColor(item?.hostname)}>
                {`${item.unit?.name}`}
              </ServerName>
              <ServerDomain>{`${item.initials.toLowerCase()}.seap.ma.br`}</ServerDomain>
            </ServerStatusHeader>

            <ServerStatus>
              {item.status === 1 ? (
                <ServerStatusOnline>Online</ServerStatusOnline>
              ) : (
                <ServerStatusOffline>Offline</ServerStatusOffline>
              )}
            </ServerStatus>
          </ServerHeader>

          {/*
           */}
          <VuiBox>
            {/*  */}
            <InfoRow>
              <InfoLabel>Endereço:</InfoLabel>
              <InfoValue>{item.unit?.address}</InfoValue>
            </InfoRow>

            <InfoRow>
              <InfoLabel>Cidade:</InfoLabel>
              <InfoValue>{item.unit?.city}</InfoValue>
            </InfoRow>

            <InfoRow>
              <InfoLabel>Contato:</InfoLabel>
              <InfoValue>{capitalize(item.unit?.contact)}</InfoValue>
            </InfoRow>

            <InfoRow>
              <InfoLabel>Telefone:</InfoLabel>
              <InfoValue>
                {item.unit.phone
                  ? item.unit.phone
                      .toString()
                      .replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3-$4")
                  : ""}
              </InfoValue>
            </InfoRow>

            <VuiLabel />

            <InfoRow>
              <InfoLabel>Operadora:</InfoLabel>
              <InfoValue>
                {item.subCarrier ? `${item.carrier} (${item.subCarrier})` : item.carrier}
              </InfoValue>
            </InfoRow>

            <InfoRow>
              <InfoLabel>IP Gateway:</InfoLabel>
              <InfoValue>
                {item.circuit ? `${item.ip} (${item.circuit.split("-")[0]})` : item.ip}
              </InfoValue>
            </InfoRow>

            <InfoRow>
              <InfoLabel>Situação:</InfoLabel>
              <InfoValue color={stageLabel[item.stage].color} fontWeight="bold">
                {stageLabel[item.stage].label}
              </InfoValue>
            </InfoRow>

            {item.status ? (
              <InfoRow>
                <InfoLabel>Latência:</InfoLabel>
                <InfoValue
                  // color={
                  //   item.ttl >= 0 && item.ttl <= 50 && item.status
                  //     ? colors.online.main
                  //     : item.ttl > 50 && item.ttl <= 100
                  //       ? colors.attention.main
                  //       : colors.error.main
                  // }
                  fontWeight="bold"
                >
                  {`${isNaN(item.ttl) ? 0 : item.ttl} ms`}
                </InfoValue>
              </InfoRow>
            ) : null}

            {!item.status && item.stage === 3 ? (
              <>
                <VuiLabel />
                {/* 
                  <VuiLabel
                    title="Gráfico das Ocorrências"
                    openLinkClick={`/occurrenceview?occurrence=${item?.currentOccurrence?.id}`}
                    fontWeightSubTitle={item?.status ? "regular" : "bold"}
                  /> 
                */}

                <VuiLabel
                  title="ID da última Ocorrência:"
                  colorTitle="black"
                  sizeTitle={12}
                  subtitle={item?.currentOccurrence?.id}
                  openLinkClick={`/occurrenceview?occurrence=${item?.currentOccurrence?.id}`}
                  colorSubTitle={"black"}
                  fontWeightSubTitle={item.status ? "400" : "bold"}
                />

                <VuiLabel
                  title="Tempo da útima Ocorrência:"
                  colorTitle="black"
                  subtitle={SLIOccurrence(
                    moment().format("DD/MM/YYYY HH:mm:ss"),
                    moment(item?.currentOccurrence?.createdAt).format("DD/MM/YYYY HH:mm:ss")
                  )}
                  colorSubTitle={"black"}
                  fontWeightSubTitle="bold"
                />
              </>
            ) : (
              <>
                <VuiLabel />
                <VuiLabel />
              </>
            )}
          </VuiBox>

          <VuiBox mt="20px" mb="20px" flexDirection="row">
            <VuiTypography
              color="black"
              style={{
                fontSize: 11,
                // fontWeight: "bold",
                textAlign: "right",
              }}
            >
              {item.status ? "Última atualização" : "Falha da conexão desde"} {item.updatedAt}
            </VuiTypography>
            {!item.status ? (
              <VuiTypography
                color="black"
                style={{
                  fontSize: 11,
                  // fontWeight: "bold",
                  textAlign: "right",
                }}
              >
                Última atualização {item.lastUpdatedAt}
              </VuiTypography>
            ) : (
              <VuiLabel />
            )}
          </VuiBox>
          {/*  */}
        </DashboardGrid>
      </>
    );
  } else {
    return <></>;
  }
}

export default VuiInfoItemLink;
